import axios from 'axios';
import { API_URL } from '../config/constants';
import { getToken } from './auth';
import BaseService from './baseService';
const rota = 'usuarios';
const service = new BaseService(rota);

const getList = async (body, skip, limit) => {
    const res = await service.getList(body, skip, limit);
    return res;
}

const upsert = async (body, id) => {
    const res = await service.upsert(body, id);
    return res;
}

const getById = async (id) => {
    const res = await service.get(`${rota}/${id}?populate_telefones&populate_enderecos&populate_documentos`);
    return res;
}

const preCadastro = async body => {
    const res = await axios.post(`${API_URL}${rota}/pre-signup`, body);
    return res.data;
}

const cadastroConsumidorFinal = async body => {
    const res = await axios.post(`${API_URL}${rota}/final-consumer`, body);
    return res.data;
}

const cadastroAdmin = async body => {
    const res = await axios.post(`${API_URL}${rota}/admin`, body);
    return res.data;
}

const cadastroRevendedora = async body => {
    const res = await axios.post(`${API_URL}${rota}/reseller`, body);
    return res.data;
}

const ativarConta = async body => {
    const res = await axios.post(`${API_URL}${rota}/activate`, body, {
        headers: {
            "Authorization": getToken()
        }
    });
    return res.data;
}

const completarCadastro = async body => {
    const res = await axios.post(`${API_URL}${rota}/complete`, body, {
        headers: {
            "Authorization": getToken()
        }
    });
    return res.data;
}

const recusarCadastro = async body => {
    const res = await axios.post(`${API_URL}${rota}/deny`, body, {
        headers: {
            "Authorization": getToken()
        }
    });
    return res.data;
}

const atualizarUsuario = async (id,body) => {
    const res = await axios.put(`${API_URL}${rota}/save/${id}`, body, {
        headers: {
            "Authorization": getToken()
        }
    });
    return res.data;
}

const tornarRevendedora = async (id) => {
    const res = await axios.get(`${API_URL}${rota}/make-reseller/${id}`, {
        headers: {
            "Authorization": getToken()
        }
    });
    return res.data;
}

const excluirTelefone = async (id) => {
    const res = await axios.get(`${API_URL}${rota}/excluir-telefone/${id}`, {
        headers: {
            "Authorization": getToken()
        }
    });
    return res.data;
}

const excluirEndereco = async (id) => {
    const res = await axios.get(`${API_URL}${rota}/excluir-endereco/${id}`, {
        headers: {
            "Authorization": getToken()
        }
    });
    return res.data;
}

const excluirDocumento = async (id) => {
    const res = await axios.get(`${API_URL}${rota}/excluir-documento/${id}`, {
        headers: {
            "Authorization": getToken()
        }
    });
    return res.data;
}

const processarCadastro = async body => {
    const res = await axios.post(`${API_URL}${rota}/process-accept`, body, {
        headers: {
            "Authorization": getToken()
        }
    });
    return res.data;
}

const recusarVariosCadastro = async body => {
    const res = await axios.post(`${API_URL}${rota}/deny-many`, body, {
        headers: {
            "Authorization": getToken()
        }
    });
    return res.data;
}

const reenviarCodigo = async () => {
    const res = await axios.get(`${API_URL}${rota}/send-activation-code`, {
        headers: {
            "Authorization": getToken()
        }
    });
    return res.data;
}

const get = async (rotaAdd) => {
    const res = await service.get(`${rota}/${rotaAdd}`);
    return res;
}

const put = async (rotaAdd, data) => {
    const res = await service.put(`${rota}/${rotaAdd}`, data);
    return res;
}

export default {
    getList,
    upsert,
    getById,
    preCadastro,
    reenviarCodigo,
    ativarConta,
    completarCadastro,
    recusarCadastro,
    processarCadastro,
    recusarVariosCadastro,
    cadastroConsumidorFinal,
    atualizarUsuario,
    excluirTelefone,
    excluirEndereco,
    excluirDocumento,
    cadastroRevendedora,
    tornarRevendedora,
    cadastroAdmin,
    get,
    put
};